/**
 * A few light-weight functions for interacting with a GraphQL query/fragment AST
 */
import {DefinitionNode, DocumentNode, FragmentDefinitionNode, OperationDefinitionNode} from 'graphql';

import {assert} from 'Asserts';

export function getFragDefFromDoc(fragment: DocumentNode, fragmentName?: string): FragmentDefinitionNode {
  if (!fragmentName) {
    assert(
      fragment.definitions.length === 1,
      'Either fragment should have exactly one definition or fragmentName must be specified'
    );
    return fragment.definitions[0] as FragmentDefinitionNode;
  } else {
    const fragDef = fragment.definitions.find(
      (f) => f.kind === 'FragmentDefinition' && f.name.value === fragmentName
    );
    assert(fragDef != null, `Fragment of name ${fragmentName} not found`);
    return fragDef as FragmentDefinitionNode;
  }
}

export function getFragmentNodeName(fragment: DocumentNode, fragmentName?: string): string {
  return getFragDefFromDoc(fragment, fragmentName).typeCondition.name.value;
}

/**
 * Get the OperationDefinitionNode that defines the query.
 *
 * Param is an object as a convenience since there are a few different types that have a "definitions" for
 * which this operation is useful.
 */
export function getQueryDefinition({
  definitions,
}: {
  definitions: ReadonlyArray<DefinitionNode>;
}): OperationDefinitionNode {
  return definitions.find(
    (def) => def.kind === 'OperationDefinition' && def.operation === 'query'
  ) as OperationDefinitionNode;
}

export function getQueryName(document: DocumentNode): string {
  return getQueryDefinition(document)?.name?.value ?? '<unnamed>';
}
